/* @flow */
import React from 'react';
import classNames from 'classnames';
import styles from './Footer.module.pcss';

type Props = {
  className?: string,
  copyright: string,
};

const Footer = ({ className, copyright }: Props) => {
  const clsString = classNames(styles.globalFooter, className);
  return (
    <footer className={clsString} data-cy="base-layout-footer">
      {copyright && <div className={styles.copyright}>{copyright}</div>}
    </footer>
  );
};

Footer.defaultProps = {
  className: '',
};

export default Footer;
